"use strict";
/*
 * Collection of functions to replace lodash
 *
 * To simplify the implementation, the functionality may be reduced to the
 * actual use-cases we have.
 */
var _this = this;
Object.defineProperty(exports, "__esModule", { value: true });
/**
 * Creates a throttled function that invokes `func` at most once per every
 * `wait` milliseconds.
 */
function throttle(func, wait, leading) {
    if (leading === void 0) { leading = false; }
    var timeout;
    var lastCall = -Infinity;
    return function () {
        var _this = this;
        var args = arguments;
        if (timeout) {
            // timeout is set, do not apply throttled function
            return;
        }
        var now = Date.now();
        var timeSinceLastCall = now - lastCall;
        if (leading && timeSinceLastCall >= wait) {
            // apply throttled function immediately
            lastCall = now;
            func.apply(this, args);
        }
        else {
            // set a timeout to run when the wait time has passed
            var timeToNextCall = timeSinceLastCall < wait ? wait - timeSinceLastCall : wait;
            timeout = setTimeout(function () {
                timeout = null;
                lastCall = Date.now();
                func.apply(_this, args);
            }, timeToNextCall);
        }
    };
}
exports.throttle = throttle;
// the debounce timeout in ms on resize of window
var DEFAULT_DEBOUNCE_TIMEOUT = 250;
/**
 * Creates a debounced function that invokes `func` only if no new call
 * has happened for `durationInMs` milliseconds.
 */
exports.debounce = function (func, durationInMs) {
    if (durationInMs === void 0) { durationInMs = DEFAULT_DEBOUNCE_TIMEOUT; }
    var timeout;
    return function () {
        var args = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            args[_i] = arguments[_i];
        }
        clearTimeout(timeout);
        timeout = setTimeout(function () {
            timeout = null;
            func.apply(_this, args);
        }, durationInMs);
    };
};
/**
 * A function that does nothing
 */
/* tslint:disable-next-line:no-empty */
function noop() { }
exports.noop = noop;
/**
 * Computes a number, rounded to precision.
 */
function round(n, precision) {
    if (precision === void 0) { precision = 0; }
    var exp = Math.pow(10, precision);
    return Math.round(n * exp) / exp;
}
exports.round = round;
/**
 * Creates an Array of numbers progressing from `start` up to, but not
 * including, `end`.
 */
function range(start, end) {
    var length = end - start;
    return Array.apply(null, Array(length)).map(function (_value, index) { return start + index; });
}
exports.range = range;
//# sourceMappingURL=nodash.js.map
